import { TrophyOutlined } from "@ant-design/icons"
import React from "react"

export const columns: Array<any> = [
    {
        title: "#",
        dataIndex: "placement",
        key: "placement",
        width: "64px",
        sorter: {
            compare: (a: any, b: any) => a.placement - b.placement,
        },
        sortDirections: ["ascend"],
        defaultSortOrder: "ascend",
        render: (text: any, record: any) => {
            switch (text) {
                case 1:
                    return ({
                        props: {
                            style: {
                                background: "#d89614",
                                color: "black"
                            }
                        },
                        children: (<><TrophyOutlined /> {text}</>)
                    })
                case 2:
                    return ({
                        props: {
                            style: {
                                background: "silver",
                                color: "black"
                            }
                        },
                        children: (<><TrophyOutlined /> {text}</>)
                    })
                case 3:
                    return ({
                        props: {
                            style: {
                                background: "#443111",
                                color: "black"
                            }
                        },
                        children: (<><TrophyOutlined /> {text}</>)
                    })
                default:
                    return text

            }
        }
    },
    {
        title: "Players",
        dataIndex: "players",
        key: "players",
    },
    {
        title: "Placement Points",
        dataIndex: "placementPoints",
        key: "placementPoints",
        sorter: {
            compare: (a: any, b: any) => a.placementPoints - b.placementPoints,
        },
        sortDirections: ["descend"]
    },
    {
        title: "Kills",
        dataIndex: "kills",
        key: "kills",
        sorter: {
            compare: (a: any, b: any) => a.kills - b.kills,
        },
        sortDirections: ["descend"]
    },
    {
        title: "Kill Points",
        dataIndex: "killPoints",
        key: "killPoints",
        sorter: {
            compare: (a: any, b: any) => a.killPoints - b.killPoints,
        },
        sortDirections: ["descend"]
    },
    {
        title: "Total Points",
        dataIndex: "totalPoints",
        key: "totalPoints",
        sorter: {
            compare: (a: any, b: any) => a.totalPoints - b.totalPoints,
        },
        sortDirections: ["descend"]
    }
]